import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const PaymentConfirmationDialog = ({ state, onClose, onRetry }) => {
  const isChecking = state === 'checking';
  const isSuccess = state === 'success';

  return (
    <Dialog
      open={Boolean(state)}
      onOpenChange={(open) => {
        if (!open && !isChecking) onClose();
      }}
    >
      <DialogContent
        className={`text-center ${isSuccess ? 'gap-8 p-8 sm:max-w-2xl sm:p-12' : 'sm:max-w-md'}`}
        overlayClassName="bg-[#EEE7D8]/80 backdrop-blur-sm"
        style={{
          backgroundColor: '#F3EEE4',
          border: '1px solid #D6D0C2',
          boxShadow: 'none',
        }}
        onEscapeKeyDown={(event) => {
          if (isChecking) event.preventDefault();
        }}
        onPointerDownOutside={(event) => {
          if (isChecking) event.preventDefault();
        }}
      >
        {!isSuccess && (
          <div
            className="mx-auto flex h-12 w-12 items-center justify-center rounded-full"
            style={{ backgroundColor: '#EEE7D8', color: '#51120A' }}
            aria-hidden="true"
          >
            <span
              className={isChecking ? 'h-6 w-6 animate-spin rounded-full border-2' : 'text-xl'}
              style={isChecking ? { borderColor: '#D6D0C2', borderTopColor: '#51120A' } : undefined}
            >
              {isChecking ? null : '…'}
            </span>
          </div>
        )}

        <DialogHeader className="text-center">
          <DialogTitle
            className={`text-center ${isSuccess ? 'text-4xl sm:text-5xl font-bold' : 'text-3xl font-normal'}`}
            style={{
              color: '#51120A',
              fontFamily: "'Instrument Serif', serif",
              lineHeight: 1.1,
            }}
          >
            {isChecking && 'Finishing your Home Cook setup'}
            {isSuccess && 'Thanks for your payment!'}
            {state === 'pending' && 'Still confirming your payment'}
          </DialogTitle>
          <DialogDescription
            className={`pt-2 text-center ${isSuccess ? 'text-base lg:text-xl' : 'text-sm'}`}
            style={{
              color: '#51120A',
              fontFamily: "'Bricolage Grotesque', sans-serif",
              opacity: isSuccess ? 1 : 0.78,
            }}
          >
            {isChecking && 'We’re confirming your payment with Stripe. This usually takes just a few seconds.'}
            {isSuccess && "We're so happy you're here to stay."}
            {state === 'pending' && 'Stripe is taking a little longer than usual. Your account has not been charged twice—you can safely check again.'}
          </DialogDescription>
        </DialogHeader>

        {isSuccess && (
          <Button
            onClick={onClose}
            className="mt-4 h-auto w-full justify-self-center px-8 py-4 text-lg font-medium text-white sm:w-auto sm:min-w-[210px]"
            style={{
              backgroundColor: '#51120A',
              fontFamily: "'Bricolage Grotesque', sans-serif",
            }}
          >
            Start cooking
          </Button>
        )}

        {state === 'pending' && (
          <div className="mt-2 flex flex-col gap-3">
            <Button
              onClick={onRetry}
              className="w-full py-5 text-sm font-medium text-white"
              style={{
                backgroundColor: '#51120A',
                fontFamily: "'Bricolage Grotesque', sans-serif",
              }}
            >
              Check again
            </Button>
            <button
              type="button"
              onClick={onClose}
              className="text-sm underline hover:opacity-70"
              style={{
                color: '#875C66',
                fontFamily: "'Bricolage Grotesque', sans-serif",
              }}
            >
              Back to my recipes
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PaymentConfirmationDialog;